document.addEventListener('DOMContentLoaded', function () {

    const discountDataBox = document.getElementById("discount-code-detail")

    const currentHandle = discountDataBox.dataset.handle
    const iso_code = discountDataBox.dataset.iso

    const discountCode = new URLSearchParams(window.location.search).get('discount')?.toUpperCase();


    let currentCodeData
    let currentCodeRate

    const default_percent = document.querySelector('.new-detail-img-code-tag .code-box .percent')?.textContent || document.querySelector('.sale-product-box-content .sale-offtxt-lable .percent')?.textContent


    const codeDetail = JSON.parse(
        discountDataBox.textContent
    );



    const page_sale_code = document.querySelector('.sale-countdown-right-code.discount-code')?.textContent

    // sale页需要更换banner图片

    // 当前折扣码
    const saleBannerCode = document.querySelector('.image_text_content-discount')?.textContent

    // sale页面banner模块
    const saleBanner = document.querySelector('.video-image-banner-section')

    // sale页保存第一个banenr的内容
    const sale_first_slide = document.querySelector('.video-image-banner .swiper-slide-image[data-swiper-slide-index="0"]')
    const first_banner_pc = sale_first_slide?.querySelectorAll('source')[1].getAttribute('srcset')
    const first_banner_mb = sale_first_slide?.querySelectorAll('source')[0].getAttribute('srcset')

    const first_banner_title = sale_first_slide?.querySelector('.image_text_content-title p')?.textContent
    const first_banner_text = sale_first_slide?.querySelector('.image_text_content-text')?.textContent


    // 更新购物车
    function updateCart() {
        const currentPageUrl = window.location.href;
        // 使用当前页面的 URL 发起请求
        $.get(currentPageUrl, function (data) {
            const $tempElement = $('<div>').html(data);
            $('.cartpage-content').html($tempElement.find('.cartpage-content').html());
            $('cart-drawer').html($tempElement.find('cart-drawer').html());
            $('.cart-icon-text').html($tempElement.find('.cart-icon-text').html());
            $('.gift-threshold-banner').html($tempElement.find('.gift-threshold-banner').html());
        }).fail(function (error) {
            console.error('Error updating cart:', error);
        });

    }

    // 更新折扣码
    function updataDiscountCode(code) {
        let formData = new FormData();
        formData.append("discount", code);
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                updateCart()
            });
    }

    // 折扣码结束事件
    function hideDiscountItem() {

        const productItems = document.querySelectorAll(`.product_discount_item`)
        productItems.forEach(item => {
            item.classList.add('hide')
            item.previousElementSibling.classList.remove('hide')
            const colPercentEl = item.closest('.grid-view-item')?.querySelector('.new-detail-img-code-tag')
            const salePercentEl = item.closest('.sale-product-box-content')?.querySelector('.sale-offtxt-lable')
            if (colPercentEl) {
                percentEl.classList.remove('hide')
            }
            if (salePercentEl) {
                salePercentEl.classList.remove('hide')
            }
        })


        //    sale页修改
        if (saleBanner) {
            const countdownCode = document.querySelector('.sale-countdown-right-code.discount-code')
            countdownCode.textContent = page_sale_code
            sale_first_slide.querySelectorAll('source')[1].setAttribute('srcset', first_banner_pc)
            sale_first_slide.querySelectorAll('source')[0].setAttribute('srcset', first_banner_mb)
            sale_first_slide.querySelector('.image_text_content-title p').textContent = first_banner_title
            sale_first_slide.querySelector('.image_text_content-text').textContent = first_banner_text
            saleBanner?.querySelectorAll('.image_text_content-button').forEach(item => {
                item.querySelector('.image_text_content-discount').textContent = saleBannerCode
                const code_desc = item.querySelector('.image_text_content-button_text.auto_discount')
                code_desc.classList.add('hide')
                code_desc.previousElementSibling.classList.remove('hide')
            })
            const countdownTitle = document.querySelector('.sale-countdown-title.auto_discount')
            countdownTitle.previousElementSibling.classList.add('hide')
            countdownTitle.classList.remove('hide')

            const auto_discount_countdown = document.querySelector('.sale-product-countdown-box.auto_discount')
            auto_discount_countdown.classList.add('hide')
            auto_discount_countdown.previousElementSibling.classList.remove('hide')
        }






        document.body.removeEventListener('click', quickAddHandler);
        filterBox?.removeEventListener('click', filterClickHandler);

    }
    function showDiscountItem() {
        const productItems = document.querySelectorAll(`.product_discount_item`)
        productItems.forEach(item => {
            item.classList.remove('hide')
            item.previousElementSibling.classList.add('hide')

        })


    }
    function renderNumber(num) {
        const str = num.toString().padStart(2, '0');
        return `<span>${str[0]}</span><span>${str[1]}</span>`;
    }

    // 折扣码有效期的倒计时
    function startCountdown() {
          let end
        if (location.pathname.includes('collections') && !currentCodeData.expiry_time) {
            //  如果是分类页且后台没有设置倒计时，跟sale一样按默认循环
            $('.product_discount_countdown  .countdown_daies').hide()
            const currentDate = new Date();
            const currentHour = currentDate.getHours();
            // 设置目标时间
            const targetDate = new Date(currentDate);
            // 如果当前时间在15点之前，设置为明天的15点；否则，设置为后天的15点
            if (currentHour < 16) {
                targetDate.setDate(currentDate.getDate() + 1); // 明天
            } else {
                targetDate.setDate(currentDate.getDate() + 2); // 后天
            }
            targetDate.setHours(15, 0, 0, 0); // 设置为15:00
            const newlastdayHTML = targetDate.toISOString(); // ISO格式字符串
            end = new Date(newlastdayHTML);

        } else {
            end = new Date(currentCodeData.expiry_time).getTime()
        }
        const timer = setInterval(() => {
            const now = Date.now();
            const distance = end - now;
            if (distance <= 0) {
                clearInterval(timer);
                // hideDiscountItem()
                const cleanUrl = window.location.origin + window.location.pathname
                window.location.href = cleanUrl
                return;
            }
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor(
                (distance % (1000 * 60 * 60 * 24))
                / (1000 * 60 * 60)
            );
            const minutes = Math.floor(
                (distance % (1000 * 60 * 60))
                / (1000 * 60)
            );
            const seconds = Math.floor(
                (distance % (1000 * 60))
                / 1000
            );
            $('.product_discount_countdown  .countdown_daies').text(String(days).padStart(2, '0') + ":");
            $('.product_discount_countdown .countdown_hours').text(String(hours).padStart(2, '0') + ":");
            $('.product_discount_countdown .countdown_minutes').text(String(minutes).padStart(2, '0') + ":");
            $('.product_discount_countdown .countdown_seconds').text(String(seconds).padStart(2, '0'));


            const sale_countdown_daies = document.getElementById('auto-discount-daies')
            const sale_countdown_hours = document.getElementById('auto-discount-hours')
            const sale_countdown_minutes = document.getElementById('auto-discount-minutes')
            const sale_countdown_seconds = document.getElementById('auto-discount-seconds')
            if (sale_countdown_daies) sale_countdown_daies.innerHTML = renderNumber(days);
            if (sale_countdown_hours) sale_countdown_hours.innerHTML = renderNumber(hours);
            if (sale_countdown_minutes) sale_countdown_minutes.innerHTML = renderNumber(minutes);
            if (sale_countdown_seconds) sale_countdown_seconds.innerHTML = renderNumber(seconds);

        }, 1000);
    }
    const quickAddHandler = (e) => {
        const button = e.target.closest('.quick-add-button-variants');

        if (!button) return;

        const productDrawerShow = setInterval(() => {
            const drawerProduct = document.querySelector(
                '#ShopNowContainer .product-single-wrapper'
            );

            if (drawerProduct) {
                const price = drawerProduct.querySelector('.new-product-pricing .money');
                const percent = drawerProduct.querySelector('.new-price-discount .percent');
                const discountItem = drawerProduct.querySelector('.product_discount_item');


                const code = drawerProduct.querySelector('.discount-code-text .discount-code');
                const countdown = drawerProduct.querySelector('.discount-countdown-left-discount');
                const percentTag = drawerProduct.querySelector('.code-box .percent')
                const new_discount_countdown_box = drawerProduct.querySelector('.new-discount-countdown-box');
                const percentText = drawerProduct.querySelectorAll('.new-price-discount span')[1]
                if (price) price.textContent = button.dataset.price;
                if (percent) percent.textContent = button.dataset.percent;
                // if (discountItem) discountItem.classList.remove('hide');
                if (code) code.textContent = discountCode;
                if (countdown) countdown.textContent = button.dataset.percent;
                if (percentTag) percentTag.textContent = button.dataset.percent;
                if (percentText) percentText.textContent = button.dataset.percent

                // if (new_discount_countdown_box) new_discount_countdown_box.classList.add('hide');
                const newCountdownCycle = drawerProduct.querySelector('.new-product-countdown-cycle');
                const discountCountdown = drawerProduct.querySelector('.product_discount_countdown')
                newCountdownCycle.replaceWith(discountCountdown.cloneNode(true));
                clearInterval(productDrawerShow);
            }
        }, 500);
    };


    const filterBox = document.querySelector('.collection-tags-filter ul');

    function filterClickHandler(e) {
        const item = e.target.closest('li');

        if (!item) return;

        if (currentCodeData) {
            updateProductMessage();
        }
    }








    function quickBtnEvent() {
        document.body.addEventListener('click', quickAddHandler);
        filterBox?.addEventListener('click', filterClickHandler);
    }

    // 货币符号
    function parseCurrency(price) {
        // 前置货币符号
        const prefix = price.match(/^[^0-9]+(?=\s*[0-9])/);

        if (prefix) {
            return {
                symbol: prefix[0],
                position: "prefix"
            };
        }

        // 后置货币符号
        const suffix = price.match(/(?<=[0-9])\s*[^0-9.,]+$/);

        if (suffix) {
            return {
                symbol: suffix[0],
                position: "suffix"
            };
        }

        return {
            symbol: "",
            position: null
        };
    }

    // 更新折扣信息
    function updateProductMessage() {
        showDiscountItem()
        const code = currentCodeData.code

        // 分类页分页器修改url携带code参数
        const pagePagination = document.querySelectorAll('.collection-main .pagination li');
        pagePagination.forEach(item => {
            const link = item.querySelector('a');
            if (!link) return;

            const url = link.getAttribute('href');
            if (!url || !url.includes('/collections')) return;

            const newUrl = new URL(url, window.location.origin);
            newUrl.searchParams.set('discount', code);

            link.setAttribute('href', newUrl.pathname + newUrl.search + newUrl.hash);
        });

        let rate = currentCodeRate
        let upTotype = false
        if (rate.includes('up-to')) {
            upTotype = true
            rate = parseInt(rate.split('-')[2])
        } else {
            rate = parseInt(parseInt(rate))
        }

        let percent = 1 - rate / 100

        const lang = document.querySelector('html').getAttribute('lang')
        const country = document.querySelector('html').dataset.country


        const productItems = document.querySelectorAll(`.product_discount_item`)
        productItems.forEach(element => {
            // 如果是up类型，需要判断产品折扣力度
            let rel_rate = rate
            let rel_percent = percent

            if (upTotype && element.getAttribute(`data-up-to-${rate}`)) {
                rel_rate = parseInt(element.getAttribute(`data-up-to-${rate}`))
                rel_percent = 1 - rel_rate / 100
            }

            element.querySelector('.discount-code').textContent = code
            // 货币符号
            const currency_item = parseCurrency(element.querySelector('.line-through-price').textContent.trim())
            const currencyCode = currency_item.symbol
            const currencyPosition = currency_item.position
            const final_price = element.querySelector('.discount-price')

            // 去掉符号的对比价
            // const compare_price = element.querySelector('.line-through-price .money')?.textContent || element.querySelector('.line-through-price')?.textContent
            // const compare_price_text = parseFloat(compare_price.replace(/[^\d.,]/g, '').replace(',', '.'))
            // let price = (Math.ceil(compare_price_text * rel_percent * 100) / 100).toFixed(2)
            const compare_price_text = element.dataset.price

            let price = (Math.ceil(compare_price_text * rel_percent) / 100).toFixed(2)
            if (country == 'PH') (
                price = Number(price).toLocaleString('en-US')
            )
            if (currencyCode.includes('€')) {
                price = price.replace('.', ',')
            }
            let finalPrice = currencyCode + price
            if (lang == 'fr' && country == 'FR') {
                finalPrice = price + currencyCode
            } else if (lang == 'de' && country == 'DE') {
                finalPrice = price + currencyCode
            } else if (currencyPosition == 'suffix') {
                finalPrice = price + currencyCode
            }
            final_price.textContent = finalPrice

            const finalPercent = rel_rate + '%'

            element.querySelector('.new-detail-img-code-tag .percent').textContent = finalPercent
            element.querySelector('.sale-offtxt-lable .percent').textContent = finalPercent

            const product_grid = element.closest('.grid-view-item') || element.closest('.sale-product-box-content')
            const colPercentEl = product_grid.querySelector('.new-detail-img-code-tag')
            if (colPercentEl) {
                colPercentEl.classList.add('hide')
            }
            const salePercentEl = product_grid.querySelector('.sale-offtxt-lable')
            if (salePercentEl) {
                salePercentEl.classList.add('hide')
            }
            const countdownCode = document.querySelector('.sale-countdown-right-code.discount-code')
            if (countdownCode) {
                countdownCode.textContent = code
            }
            const quickAddBtn = product_grid.querySelector('.quick-add-button-variants')
            if (quickAddBtn) {
                quickAddBtn.dataset.price = finalPrice
                quickAddBtn.dataset.percent = finalPercent
            }

            if (!currentCodeData.expiry_time && currentHandle == 'sale') {
                element.querySelector('.product_discount_countdown').classList.add('hide')
            }

        });

        // 修改sale页面内容
        if (saleBanner) {
           
            let file_name_pc = currentCodeData.banner_pc
            let file_name_mb = currentCodeData.banner_mb
            let code_title = currentCodeData.title
            let code_subtitle = currentCodeData.subtitle
            let text_color = currentCodeData.text_color
             for (let i = 1; i <= 3; i++) {
                const market = currentCodeData[`market_${i}`];
                if (market?.includes(iso_code)) {
                    const title = currentCodeData[`market_${i}_title`];
                    const subtitle = currentCodeData[`market_${i}_subtitle`];
                    const bannerPc = currentCodeData[`market_${i}_banner_pc`];
                    const bannerMb = currentCodeData[`market_${i}_banner_mb`];
                    const textColor = currentCodeData[`market_${i}_text_color`];

                    if (title) code_title = title;
                    if (subtitle) code_subtitle = subtitle;
                    if (bannerPc) file_name_pc = bannerPc;
                    if (bannerMb) file_name_mb = bannerMb;
                    if (textColor) text_color = textColor;

                    break;
                }
            }
            if (text_color) {
                sale_first_slide.querySelector('.image_text-slide-content-box').style.color = text_color
            }
            if (file_name_pc) {
                sale_first_slide.querySelectorAll('source')[1].setAttribute('srcset', file_name_pc)
                sale_first_slide.querySelector('img').setAttribute('src', file_name_pc)
            }
            if (file_name_mb) {
                sale_first_slide.querySelectorAll('source')[0].setAttribute('srcset', file_name_mb)
            }

            const sale_first_title =  sale_first_slide.querySelector('.image_text_content-title p')
            if (code_title && sale_first_title) {
                sale_first_title.innerHTML = code_title
            }
            const sale_first_subtitle = sale_first_slide.querySelector('.image_text_content-text')
            if (code_subtitle && sale_first_subtitle) {
                sale_first_subtitle.innerHTML = code_subtitle
            }
            sale_first_slide.querySelector('.image_text-slide-content').style.display= 'block'
            const salePercent = currentCodeRate.replace('up-to-', '') + '%'
            saleBanner.querySelectorAll('.image_text_content-button').forEach(item => {
                item.querySelector('.image_text_content-discount').textContent = code
                const code_desc = item.querySelector('.image_text_content-button_text.auto_discount')
                code_desc.innerHTML = code_desc.innerHTML.replace(/\d+(\.\d+)?%/g, salePercent)
                if (currentCodeRate.includes('up-to')) {
                    code_desc.querySelector('.sitewide').classList.add('hide')
                    code_desc.querySelector('.up_to').classList.remove('hide')
                } else {
                    code_desc.querySelector('.sitewide').classList.remove('hide')
                    code_desc.querySelector('.up_to').classList.add('hide')
                }
                code_desc.previousElementSibling.classList.add('hide')
                code_desc.classList.remove('hide')
            })
            const countdownTitle = document.querySelector('.sale-countdown-title.auto_discount')
            countdownTitle.innerHTML = countdownTitle.innerHTML.replace(/\d+(\.\d+)?%/g, salePercent)
            const swiperSaleCode = document.querySelector('.box-content.swiper-Sale .sale-exclusive-slide-box-title')
            if (currentCodeRate.includes('up-to')) {
                countdownTitle.querySelector('.sitewide').classList.add('hide')
                countdownTitle.querySelector('.up_to').classList.remove('hide')
                swiperSaleCode.textContent = 'Get up to ' + rate + '% OFF with code ' + code
            } else {
                countdownTitle.querySelector('.sitewide').classList.remove('hide')
                countdownTitle.querySelector('.up_to').classList.add('hide')
                swiperSaleCode.textContent = 'Get ' + rate + '% OFF with code ' + code
            }
            countdownTitle.previousElementSibling.classList.add('hide')
            countdownTitle.classList.remove('hide')

            if (currentCodeData.expiry_time) {
                const auto_discount_countdown = document.querySelector('.sale-product-countdown-box.auto_discount')
                auto_discount_countdown.classList.remove('hide')
                auto_discount_countdown.previousElementSibling.classList.add('hide')
            }
        }
    }


    if (discountCode) {
        currentCodeData = codeDetail.find(
            item => item.code === discountCode
        );
        currentCodeRate = currentCodeData.percent
        if (currentCodeData && currentCodeData.handles.includes(currentHandle)) {
            //判断折扣码是否过期
            const endtime = currentCodeData.expiry_time
            if (Date.now() < new Date(endtime).getTime() || !endtime) {
                updataDiscountCode(discountCode)
                updateProductMessage(discountCode)
                if (endtime || location.pathname.includes('collections')) {
                    startCountdown()
                }
                quickBtnEvent()
                localStorage.setItem('last_discount_handle', currentHandle)
                document.querySelector('body').classList.add('auto-discount')

            } else {
                updataDiscountCode('')
            }
        }
    } else {

        if (localStorage.getItem('last_discount_handle') == currentHandle) {
            localStorage.removeItem('last_discount_handle')
            updataDiscountCode('')
        }

    }

})